import React, { useState } from 'react';
import './login.css';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { Circles } from 'react-loader-spinner'; // ✅ Import loader
import BASE_URL from '../config';

const MySwal = withReactContent(Swal);

const showToast = (icon, title, text) => {
  MySwal.fire({
    toast: true,
    position: 'top',
    icon: icon,
    title: title,
    text: text,
    showConfirmButton: false,
    timer: 2000,
    timerProgressBar: true,
  });
};

const LoginPage = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false); // ✅ loader state

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: '' });
  };

  const validate = () => {
    const newErrors = {};
    if (!form.email) newErrors.email = 'Email is required';
    if (!form.password) newErrors.password = 'Password is required';
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setLoading(true); // ✅ show loader

    try {
      const response = await axios.post(`${BASE_URL}/api/login`, form, {
        headers: { Accept: 'application/json' }
      });

      const message = response.data?.message || "OTP sent";
      const messageemail = response.data?.email || "Email";

  showToast("success", "Success",`${message}\n📧 ${messageemail}`);
      // showToast('success', 'Login Successful', 'Welcome!');
      localStorage.setItem("userdata", JSON.stringify(response.data?.user));
      localStorage.setItem("token", response.data?.token);
      localStorage.setItem('otp_email', form.email);


    // 👉 Redirect to OTP page
    navigate('/verify-otp');
    } catch (error) {
      console.error('Login failed:', error);
      const message = error?.response?.data?.message || 'Login failed. Check credentials.';
      showToast('error', 'Login Failed', message);
    } finally {
      setLoading(false); // ✅ hide loader
    }
  };

  return (
    
    <div className="loginscreen d-flex align-items-center justify-content-center">
      <div className="login-box p-4 shadow text-center">
        <h4 style={{ color: '#fff' }}>
          BI <span style={{ color: '#FF650F' }}>Manager</span>
        </h4>

        {loading ? (
          <div className="d-flex justify-content-center my-4">
            <Circles height="50" width="50" color="#FF650F" />
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="form-group mb-3">
              <input
                type="email"
                name="email"
                className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                placeholder="Email"
                value={form.email}
                onChange={handleChange}
              />
              {errors.email && <div className="invalid-feedback">{errors.email}</div>}
            </div>
            <div className="form-group mb-3">
              <input
                type="password"
                name="password"
                className={`form-control ${errors.password ? 'is-invalid' : ''}`}
                placeholder="Password"
                value={form.password}
                onChange={handleChange}
              />
              {errors.password && <div className="invalid-feedback">{errors.password}</div>}
            </div>
            <button type="submit" className="btn btn-primary btn-block w-100 mt-2">
              Login
            </button>
            <Link to="/forgetpassword">Forget Password?</Link>

          </form>
        )}
      </div>
    </div>

  );
};

export default LoginPage;
